<div fxLayout="row wrap" fxLayoutAlign="center">

  <!-- <ng-container *ngIf="cargando">
  <div fxLayout="column" fxLayoutAlign="space-between center" class="pt-40">
  <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
  <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
</div>
</ng-container> -->

<ng-container >
  <mat-tab-group style="width: 100%; background: white;" (selectedTabChange)="onLinkClick($event)"  [selectedIndex]="tabCrear">
    <mat-tab label="{{'FOCUS.GRUPOS.ADMIN' | translate}}">

      <adming
      (CambioTab)="CambioTab($event)"
      (infoGrupoFocus)="infoGrupoFocus($event)"
      (EditarNom)="cambiarNombre($event)"
      [actualizaGrupos]="eventsSubject.asObservable()">
    </adming>

  </mat-tab>

  <mat-tab label= '{{editarCrear  | translate}}'>
    <crearg
    (CambioTab)="actualizarGrupos($event)"
    [datosInfoGrupo]="datosInfoGrupo.asObservable()">
  </crearg>

</mat-tab>
</mat-tab-group>
</ng-container>
</div>
